// 有福利测试环境
export const dev_port=process.env.NODE_ENV === 'production' ? 
    // 生产环境
    'http://47.102.122.200/mall' 
    : 
    // 测试环境
    'http://47.102.122.200/mall' 

    // 'http://139.196.146.86/mall'
    
export const buy=dev_port+'/rest/mall/buy'
export const award=dev_port+'/rest/mall/award'
export const my_goods=dev_port+'/rest/mall/my-goods'
export const fill_qq=dev_port+'/rest/fill-qq'
export const fill_address=dev_port+'/rest/mall/fill-address'
export const inventory=dev_port+'/rest/mall/inventory'
export const login=dev_port+'/rest/login'
export const my_address=dev_port+'/rest/mall/my-address'